import Logo from "../menu/Logo";
import classes from "./LoggedOut.module.scss";
import dddLogo from "../../assets/logo.svg";
import eLogo from "../../assets/evropalogobel.webp";
import LanguageSelector from "../UI/LanguageSelector";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ThemeContext } from "../../store/ThemeContext";
import { useTranslation } from 'react-i18next';
import { LoggedOutHeaderContext } from "../../store/LoggedOutHeaderContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

// Routes that keep the existing minimal header — everything else (login, sign-up, reset
// password, change password, and the logged-out catch-all which also resolves to Login)
// gets the full marketing nav.
const minimalHeaderRoutes = ["confirmemail"];

const LoggedOutWrapper = ({ children }) => {
  const {logo} = useContext(ThemeContext);
  const location = useLocation();
  const { t } = useTranslation();
  const isMinimalHeaderRoute = minimalHeaderRoutes.some(p => location.pathname.replace(/^\//, "").startsWith(p));
  const showMarketingNav = !logo && !isMinimalHeaderRoute;
  const [mobileHeading, setMobileHeading] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Close the drawer on route change (e.g. tapping "Log in" inside it) rather than
  // leaving it stuck open over the next page.
  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <div className={classes["wrapper"]}>
        {showMarketingNav ? (<>
            {/* No desktop nav bar above the card on login/sign-up/reset/change-password —
                removed per request, to keep the funnel focused rather than inviting
                visitors back to the marketing site mid-flow. Each page's own in-card
                language selector (.loginFlagWrap) already covers what the nav's language
                switching would have. Mobile still gets a header band below (next block) —
                that one carries the page's own heading, not marketing nav links, so it
                stays regardless. */}
            <header className={classes.mobileHeaderBand}>
                <div className={classes.mobileHeaderTop}>
                    <a href="@" className={classes.mobileHeaderLogo}>
                        <img src={dddLogo} alt="" />
                        <span>DDD Invoices</span>
                    </a>
                    <button
                        type="button"
                        className={classes.mobileHeaderMenuBtn}
                        aria-label={drawerOpen ? t("Close menu") : t("Open menu")}
                        aria-expanded={drawerOpen}
                        onClick={() => setDrawerOpen(open => !open)}
                    >
                        {drawerOpen ? <CloseIcon/> : <MenuIcon/>}
                    </button>
                </div>
                {mobileHeading && <h1 className={classes.mobileHeaderHeading}>{mobileHeading}</h1>}
            </header>
            {drawerOpen && <div className={classes.mobileDrawer}>
                <a href="https://dddinvoices.com" target="_blank" rel="noopener noreferrer">{t("Why")}</a>
                <a href="https://dddinvoices.com/platform-e-invoicing-invoicing-fiscalization-api" target="_blank" rel="noopener noreferrer">{t("Platform")}</a>
                <a href="https://dddinvoices.com" target="_blank" rel="noopener noreferrer">{t("Solutions")}</a>
                <a href="https://dddinvoices.com/pricing" target="_blank" rel="noopener noreferrer">{t("Pricing")}</a>
                <a href="https://dddinvoices.com" target="_blank" rel="noopener noreferrer">{t("Learn")}</a>
                <a href="https://dddinvoices.com" target="_blank" rel="noopener noreferrer">{t("For developers")}</a>
                <div className={classes.mobileDrawerDivider}/>
                <a href="/login">{t("Log in")}</a>
                <a href="@dashboard-sign-up" className={classes.mobileDrawerSignup}>{t("Sign up")}</a>
            </div>}
        </>) : (<>
            <header className={`d-flex ${classes["header"]}`}>
                <a href="@">
                    {!logo && <img src={dddLogo} alt="" className={classes.logo}/>}
                    {logo && <img src={process.env.REACT_APP_ORIGIN ? process.env.REACT_APP_ORIGIN+"/"+logo.replace("File", "Public") : logo.replace("File", "Public")} alt="" className={classes.logo} style={{width:"120px"}}/>}
                </a>
            </header>
            <div className={`${classes["language"]}`}><LanguageSelector imgWidth="35"/></div>
        </>)}
        <div className={classes.contentArea}>
            <LoggedOutHeaderContext.Provider value={setMobileHeading}>
                {children}
            </LoggedOutHeaderContext.Provider>
        </div>
    </div>
  );
}
export default LoggedOutWrapper;
